import { render } from "./Fase2Page.vue?vue&type=template&id=3d11843c&scoped=true"
const script = {}

import "./Fase2Page.vue?vue&type=style&index=0&id=3d11843c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d11843c"]])

export default __exports__